<!--赖传峰-->
<!--2022/8/29-->
<template>
  <div class="storage-info">
    <div class="statistics">{{ storageUnit(userInfo.usage, 2) }} / {{ storageUnit(userInfo.limit, 0) }}</div>
    <ElTooltip
      v-bind="TOOLTIP_COMMON_PROPS"
      :offset="6"
      :content="$t('pgJoamkcg24rUmEs0xI0k')"
    >
      <a
        style="height: 16px; width: 16px"
        :href="`/drive/all/${RouteQueryKey.ACTION}=${RouteQueryKeyActionValue.SHOW_STORAGE_DIALOG}`"
      >
        <i class="icon icon-info" />
      </a>
    </ElTooltip>
  </div>
</template>

<script lang="ts" setup>
import { useUserInfo } from '@/store/userInfo'
import { storageUnit } from '@/utils'
import { TOOLTIP_COMMON_PROPS } from '~/types/constants'
import { RouteQueryKey, RouteQueryKeyActionValue } from '~/types/enum'

const userInfo = useUserInfo()
</script>

<style lang="less" scoped>
@import '@/assets/styles/util.less';

.storage-info {
  line-height: 18px;
  height: 18px;
}

.icon {
  display: block;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.icon-info {
  mask: url('@/assets/images/sidebar/circle-info.svg') var(--no-repeat-contain-center);
  -webkit-mask: url('@/assets/images/sidebar/circle-info.svg') var(--no-repeat-contain-center);
  background-color: #aaa;
  transition: background-color var(--transition-delay) var(--transition-animation);

  &:hover {
    background-color: var(--color-primary);
  }
}

.statistics {
  color: var(--color-secondary-text);
}

@media screen and (max-width: @mobile-break-width) {
  .storage-info {
    display: flex;
    align-items: center;
  }

  .icon {
    margin-left: 4px;
    display: inline-block;
  }
}
</style>
